import { IGetControleCentroCustoEstatisticasUseCase } from "../../../presentation/useCases/read/get_controle_centro_custo_estatisticas_use_case";
import { ControleEstatisticas } from "../../models/controle_estatisticas";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetControleCentroCustoEstatisticasUseCase
 */

export class GetControleCentroCustoEstatisticasUseCase implements IGetControleCentroCustoEstatisticasUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getControleCentroCustoEstatisticas(
    idControleCentroCusto: number | undefined,
  ): Promise<ControleEstatisticas> {
    if (idControleCentroCusto === undefined) throw new Error('Falha ao obter id do controle de centro de custo!');
    const response = await this.repository.getControleCentroCustoEstatisticas(idControleCentroCusto);
    if (response === null) throw new Error('Falha ao buscar dados do controle de centro de custo!');
    return response;
  }
}
